import { ORGANIZATION, SITE_URL, absoluteUrl, buildActivistPath, buildReportPath } from './siteConfig';

export function organizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: ORGANIZATION.name,
    legalName: ORGANIZATION.legalName,
    url: ORGANIZATION.url,
    logo: ORGANIZATION.logo,
    email: ORGANIZATION.email,
    sameAs: [SITE_URL],
  };
}

export function datasetSchema({ totalReports, totalActivists, sectors } = {}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Dataset',
    name: `${ORGANIZATION.name} Activist Short Seller Reports`,
    description: 'Database of activist short seller research reports.',
    url: absoluteUrl('/reports'),
    creator: {
      '@type': 'Organization',
      name: ORGANIZATION.name,
      url: ORGANIZATION.url,
    },
    ...(totalReports != null && {
      size: `${totalReports} reports`,
    }),
    ...(totalActivists != null && {
      variableMeasured: `${totalActivists} activist short sellers`,
    }),
    ...(Array.isArray(sectors) &&
      sectors.length > 0 && {
        keywords: sectors.join(', '),
      }),
  };
}

export function personProfileSchema({ name, totalReports, companiesTargeted, url }) {
  return {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    mainEntity: {
      '@type': 'Person',
      name,
      url: url || absoluteUrl(buildActivistPath(name)),
      ...(totalReports != null && {
        description: `${totalReports} activist short seller reports`,
      }),
      ...(companiesTargeted != null && {
        knowsAbout: `${companiesTargeted} targeted companies`,
      }),
    },
  };
}

export function reportArticleSchema({
  activist,
  reportTitle,
  targetCompany,
  ticker,
  publicationDate,
  sector,
  externalUrl,
}) {
  const pageUrl = absoluteUrl(buildReportPath(activist, reportTitle));
  return {
    '@context': 'https://schema.org',
    '@type': 'Report',
    name: reportTitle,
    headline: reportTitle,
    author: {
      '@type': 'Person',
      name: activist,
      url: absoluteUrl(buildActivistPath(activist)),
    },
    ...(publicationDate && { datePublished: publicationDate }),
    url: pageUrl,
    ...(externalUrl && { sameAs: externalUrl }),
    about: {
      '@type': 'Organization',
      name: targetCompany || reportTitle,
      ...(ticker && { tickerSymbol: ticker }),
      ...(sector && { industry: sector }),
    },
    publisher: {
      '@type': 'Organization',
      name: ORGANIZATION.name,
      url: ORGANIZATION.url,
      logo: {
        '@type': 'ImageObject',
        url: ORGANIZATION.logo,
      },
    },
  };
}

export function breadcrumbSchema(items) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: absoluteUrl(item.path),
    })),
  };
}

export function serializeJsonLd(data) {
  if (!data) return null;
  const payload = Array.isArray(data) ? data.filter(Boolean) : [data].filter(Boolean);
  if (payload.length === 0) return null;
  return JSON.stringify(payload.length === 1 ? payload[0] : payload);
}
